import type { components } from '@/types/api-schema';

export type DateTimeType = components['schemas']['DateTimeType'];

/**
 * 各タイプの定数
 *
 * `satisfies` の型に mapped type を使うことで、SSOT（OpenAPI 生成型）に新しい
 * DateTimeType 値が追加された際に、このオブジェクトの項目不足がコンパイルエラーとして
 * 検出される。キー名は値の uppercase と一致させる必要がある。
 */
export const DATETIME_TYPE = {
  FIXED: 'fixed',
  POLL: 'poll',
  UNDECIDED: 'undecided',
} as const satisfies { [K in DateTimeType as Uppercase<K>]: K };

